// 20MB raw → ~26MB after base64 encoding, fits within the SMTP limit with margin.
export const MAX_TOTAL_ATTACHMENT_SIZE = 20 * 1024 * 1024

// Allowed types per BE contract (OPSSTD-3643): pdf doc docx xls xlsx png jpg jpeg txt
export const ALLOWED_ATTACHMENT_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/png',
    'image/jpeg',
    'text/plain'
]

// Lowercase, no leading dot. Used as a fallback when `file.type` is empty or
// unrecognized by the browser (common for PDFs dragged from external apps).
export const ALLOWED_ATTACHMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'png', 'jpg', 'jpeg', 'txt']

// Combined extensions + MIME types for the file input `accept` attribute.
export const ALLOWED_ATTACHMENT_ACCEPT = [
    ...ALLOWED_ATTACHMENT_EXTENSIONS.map(ext => `.${ext}`),
    ...ALLOWED_ATTACHMENT_TYPES
].join(',')

// Design doc caps the subject at 120 chars with a visible counter (BE accepts up to 200).
export const SUBJECT_MAX_LENGTH = 120

// Debounce for the live recipient preview while the user edits filters.
export const PREVIEW_DEBOUNCE_MS = 500

// The BE returns the first 5 recipients in the preview sample (contract §1).
export const PREVIEW_SAMPLE_SIZE = 5

// Page size for the paginated recipients browser (OPSSTD-3649, /mailer/recipients). BE default 20, max 100.
export const MAILER_RECIPIENTS_LIST_PAGE_SIZE = 20

// Rollout safety switch: while true, the definitive send button stays
// disabled with an explanatory tooltip and only test sends are allowed.
// Flip to false to unlock mass sending.
export const MAILER_SEND_LOCKED = true

// Batch detail modal page size per functional spec §10.1.
export const BATCH_DETAIL_PAGE_SIZE = 8

// History list page size.
export const HISTORY_PAGE_SIZE = 10
